import { useMemo } from "react";

import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { FlowsheetTemplate } from "../Models/FlowsheetTemplate";

const flowsheetTypeTemplateToVocabMap = {
    ["DiabetesDefault"]: "Flowsheets_DiabetesDefaultLabel",
    ["AsthmaDefault"]: "Flowsheets_AsthmaDefaultLabel",
    ["ChronicObstructivePulmonaryDiseaseDefault"]: "Flowsheets_ChronicObstructivePulmonaryDiseaseDefaultLabel",
    ["HeartFailureDefault"]: "Flowsheets_HeartFailureDefaultLabel",
    ["HypertensionDefault"]: "Flowsheets_HypertensionDefaultLabel"
};

function useGetFlowsheetName(): { getName: (flowsheetTemplate: FlowsheetTemplate) => string } {
    const { getText } = useTranslation();

    return useMemo(
        () => ({
            getName: (flowsheetTemplate: FlowsheetTemplate): string => flowsheetTemplate?.IsDefaultTemplate
                ? getText(flowsheetTypeTemplateToVocabMap[flowsheetTemplate.Name])
                : flowsheetTemplate?.Name
        }),
        [getText]
    );
}

export { useGetFlowsheetName };
